import { useEffect, useRef } from 'react';

interface VideoTileProps {
  stream: MediaStream | null;
  /** Local self-view must be muted to avoid audio feedback. */
  muted?: boolean;
  label?: string;
  className?: string;
}

/** Renders a MediaStream into a <video>, keeping srcObject in sync. */
const VideoTile: React.FC<VideoTileProps> = ({
  stream,
  muted = false,
  label,
  className = '',
}) => {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el && el.srcObject !== stream) {
      el.srcObject = stream;
    }
  }, [stream]);

  return (
    <div className={'video-tile ' + className}>
      <video ref={ref} autoPlay playsInline muted={muted} />
      {label && <span className="video-tile-label">{label}</span>}
    </div>
  );
};

export default VideoTile;
